// =============================================================================
// _freeze.ts — shared deepFreeze utility
// Extracted from rng.ts so aura-manager and pending-effect-queue can reuse it
// without duplication. WeakSet visited set prevents infinite loops on cyclic
// input (defense-in-depth; normal game state is acyclic).
// =============================================================================

/**
 * Recursively freezes an object and all of its owned property values.
 * Safe against cyclic references via WeakSet visited tracking.
 * Returns the input value (for chaining convenience).
 */
export function deepFreeze<T>(o: T, visited: WeakSet<object> = new WeakSet()): T {
  if (o === null || typeof o !== "object") return o;
  if (Object.isFrozen(o)) return o;
  if (visited.has(o as object)) return o;
  visited.add(o as object);
  for (const key of Object.getOwnPropertyNames(o)) {
    deepFreeze((o as Record<string, unknown>)[key], visited);
  }
  return Object.freeze(o);
}
